import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faQuestionCircle } from '@fortawesome/free-solid-svg-icons';
import { Col, OverlayTrigger, Row, Tooltip } from 'react-bootstrap';
import { useMyContentContext } from '../utils/myContentContext';
import QuestionTypes from '../../../enums/questionTypes';
import Slider from 'rc-slider';
import { useEffect, useState } from 'react';

const CreateAnswerOption = () => {
  const { numChoices,
    setNumChoices,
    correctAnswer,
    setCorrectAnswer,
    questionType,
    setQuestionType,
    fillInAnswer,
    setFillInAnswer,
    fillInAnswerBoxWidth,
    setFillInAnswerBoxWidth,
    fillInAnswerBoxFontSize,
    setFillInAnswerBoxFontSize
  } = useMyContentContext();

  const [answerBoxWidthInput, setAnswerBoxWidthInput] = useState(String(fillInAnswerBoxWidth));
  const [answerBoxFontSizeInput, setAnswerBoxFontSizeInput] = useState(String(fillInAnswerBoxFontSize));

  useEffect(() => {
    setAnswerBoxWidthInput(String(fillInAnswerBoxWidth));
  }, [fillInAnswerBoxWidth]);

  useEffect(() => {
    setAnswerBoxFontSizeInput(String(fillInAnswerBoxFontSize));
  }, [fillInAnswerBoxFontSize]);

  const handleBoxValueChange = (value, min, max, setter) => {
    const num = Number(value);
    if (!Number.isNaN(num)) {
      setter(Math.min(max, Math.max(min, num)));
    }
  };

  const handleAnswerBoxWidthChange = (e) => {
    const value = e.target.value;
    setAnswerBoxWidthInput(value);
    if (value === '') {
      return;
    }
    handleBoxValueChange(e.target.value, 1, 50, setFillInAnswerBoxWidth);
  };

  const handleAnswerBoxFontSizeChange = (e) => {
    const value = e.target.value;
    setAnswerBoxFontSizeInput(value);
    if (value === '') {
      return;
    }
    handleBoxValueChange(e.target.value, 1, 20, setFillInAnswerBoxFontSize);
  };

  const handleAnswerBoxWidthBlur = () => {
    if (answerBoxWidthInput === '') {
      setAnswerBoxWidthInput('1');
      setFillInAnswerBoxWidth(1);
      return;
    }

    const num = Number(answerBoxWidthInput);
    if (Number.isNaN(num)) {
      setAnswerBoxWidthInput(String(fillInAnswerBoxWidth));
      return;
    }

    handleBoxValueChange(answerBoxWidthInput, 1, 50, setFillInAnswerBoxWidth);
  };

  const handleAnswerBoxFontSizeBlur = () => {
    if (answerBoxFontSizeInput === '') {
      setFillInAnswerBoxFontSize(1);
      return;
    }
    handleBoxValueChange(answerBoxFontSizeInput, 1, 20, setFillInAnswerBoxFontSize);
  };

  return (
    <>
      <div className='bg-white mb-4 rounded-4 p-4'>
        <div className='d-flex justify-content-between w-100 mb-3'>
          <div>
            <h5 >Question Type</h5>
            <div className="d-flex gap-3 mb-4 mt-4">
              <div className='gap-2 d-flex'>
                <input
                  type="radio"
                  className="form-check-input cursor-pointer"
                  id="mc"
                  checked={questionType == 1}
                  onChange={() => setQuestionType(1)}
                />
                <label className="form-check-label">
                  Multiple Choice
                </label>
                <OverlayTrigger
                  key="modal-overlay"
                  placement="right"
                  overlay={
                    <Tooltip className="initial-assignment-tooltip">
                      For Multiple Choice questions, make sure the answer choices are included with the question because this is what the students will see.<br /><br />In the Answer section of this page, specify the following:
                      <ul><li>Answer - the correct multiple choice answer</li><li>Number of choices - the number of choices that are being presented to the student.</li></ul>
                    </Tooltip>
                  }>
                  <FontAwesomeIcon className="mt-1 clr-fa-circle-question" icon={faQuestionCircle} />
                </OverlayTrigger>
              </div>
              <div className='gap-2 d-flex'>
                <input
                  type="radio"
                  className="form-check-input cursor-pointer"
                  id="fillin"
                  checked={questionType == 2}
                  onChange={() => setQuestionType(2)}
                />
                <label className="form-check-label">
                  Fill in
                </label>
                <OverlayTrigger
                  key="modal-overlay"
                  placement="right"
                  overlay={
                    <Tooltip className="initial-assignment-tooltip">
                      For Fill-In questions, make sure that this string:<br />&nbsp;&nbsp;&nbsp;~~1~~<br /> is included in the question because this is where an input box is displayed when the student views the question.<br /><br />In the Answer section of this page,
                      specify the following:<ul><li><br />Answer - the answer to the question. Note that if the answer is a number any equivalent number will be considered to be correct (for example, 2 is the same as 2.0).
                        If the answer is text, then case will not matter.</li><li><br />Answer Box Width - specify the maximum number of characters the student can enter. Note that the browser may display a wider edit box than specified.
                      </li><li><br />Answer Box Font Size - controls the size of the answer box. Generally, you should set it to the same size as the text in the question. The default (normal) should be used if you have not set the text size of the question.</li></ul>

                    </Tooltip>
                  }>
                  <FontAwesomeIcon className="mt-1 clr-fa-circle-question" icon={faQuestionCircle} />
                </OverlayTrigger>
              </div>
            </div>
          </div>
        </div>
        {questionType == QuestionTypes.MC &&
          <div className='d-flex gap-5'>
            <div>
              <p>Number of Choices</p>
              <div className="questions-numbers-list edit flex-shrink-0 w-100">
                <div className='d-flex flex-wrap gap-2'>
                  {Array.from({ length: 10 }).map((_, index) => (
                    <>
                      <button
                        key={`questionButton-${index}`}
                        onClick={() => setNumChoices(index + 1)}
                        className={`cursor-pointer question-list-item btn ${(numChoices == index + 1) ? 'btn-castleRed' : 'btn-castleGray'}`}
                      >
                        {index + 1}
                      </button>
                    </>
                  ))}
                </div>
              </div>
            </div>
            <div>
              <p>Correct Answer</p>
              <div className="questions-numbers-list edit flex-shrink-0 w-100">
                <div className='d-flex flex-wrap gap-2'>
                  {Array.from({ length: 10 }).map((_, index) => (
                    <>
                      <button
                        key={`questionButton-${index}`}
                        onClick={() => setCorrectAnswer(index + 1)}
                        className={`cursor-pointer question-list-item btn ${(correctAnswer == index + 1) ? 'btn-castleRed' : 'btn-castleGray'}`}
                      >
                        {index + 1}
                      </button>
                    </>
                  ))}
                </div>
              </div>
            </div>
          </div>
        }
        {questionType == QuestionTypes.FillIn &&
          <div>
            <h4>Question Answer</h4>
            <p className='text-success mt-4'>
            WARNING: You should only use fill-ins for exact answer matches, such as numeric values, spelling words, or short text such as Y/N or T/F (yes/no or true/false). The student&apos;s response must match the expected answer character for character in order to be scored as correct.<br/>
            HOWEVER, quotes are ignored in the student&apos;s response.<br/>
            Ex. if you set the correct answer as <strong>Sam&apos;s Club</strong> the following will count as correct:<br/>
              <strong>Sam&apos;s Club   Sams Club</strong><br/>
              <strong>Sam&apos;s Club   Sam&apos;s Club</strong><br/>
            </p>
            <hr className='mt-4' />
            <h6 className='mt-4'>Answer</h6>
            <input
              type='text'
              value={fillInAnswer}
              onChange={(e)=>setFillInAnswer(e.target.value)}
              className='form-control mb-4 mt-3'
              maxLength={50}
            />
            <Row className='mb-5'>
              <Col>
                <div className='d-flex justify-content-between'>
                  <label className='align-items-center d-flex'>Answer Box Width</label>
                  <input
                    type="number"
                    value={answerBoxWidthInput}
                    className="form-control w-15 text-lg-center text-secondary"
                    id="answerBoxWidth"
                    onChange={handleAnswerBoxWidthChange}
                    onBlur={handleAnswerBoxWidthBlur}
                  />
                </div>
                <div className="sliding-bar pt-2">
                  <Slider
                    min={1}
                    max={50}
                    value={fillInAnswerBoxWidth}
                    onChange={(e) => setFillInAnswerBoxWidth(Number(e))}
                    marks={{ 1: 1, 50: 50 }}
                  />
                </div>
              </Col>
              <Col>
                <div className='d-flex justify-content-between'>
                  <label className='align-items-center d-flex'>Answer Box Font Size</label>
                  <input
                    type="number"
                    value={answerBoxFontSizeInput}
                    className="form-control w-15 text-lg-center text-secondary"
                    id="answerBoxFontSize"
                    onChange={handleAnswerBoxFontSizeChange}
                    onBlur={handleAnswerBoxFontSizeBlur}
                  />
                </div>
                <div className="sliding-bar pt-2">
                  <Slider
                    min={1}
                    max={20}
                    value={fillInAnswerBoxFontSize}
                    onChange={(e) => setFillInAnswerBoxFontSize(Number(e))}
                    marks={{ 1: 1, 20: 20 }}
                  />
                </div>
              </Col>
            </Row>
          </div>
        }
      </div>
    </>
  );
};

export default CreateAnswerOption;